
const _ = require('lodash');

const vb = require('../definition');

const {
	unwrap,
} = require('../util');

vb.fileUploadFulfilled = _.constant(vb.all([
	vb.custom(f => {
		const state = f && f.Upload.State();
		return !state
			|| state === 'fulfilled'
			|| state === 'rejected';
	}, 'дождитесь завершения загрузки'),
	vb.custom(f => {
		const state = f && f.Upload.State();
		return state !== 'rejected';
	}, 'загрузка файла не удалась'),
]));

vb.universalFileUploadFulfilled = _.constant(vb.all([
	vb.custom(v => {
		const isValid = _.flattenDeep([v]).every(f => {
			const file = f && unwrap(f);
			const state = file && file.Upload.State();
			return !state
				|| state === 'fulfilled'
				|| state === 'rejected';
		});

		return isValid;
	}, 'дождитесь завершения загрузки'),
	vb.custom(v => {
		const isValid = _.flattenDeep([v]).every(f => {
			const file = f && unwrap(f);
			const state = file && file.Upload.State();
			return state !== 'rejected';
		});

		return isValid;
	}, 'загрузка файла не удалась'),
]));
